import { render, staticRenderFns } from "./UserDefinedGroupClass.vue?vue&type=template&id=c1b6396a"
import script from "./UserDefinedGroupClass.vue?vue&type=script&lang=js"
export * from "./UserDefinedGroupClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports